import { render, staticRenderFns } from "./QuoteSlice.vue?vue&type=template&id=00c52328&"
import script from "./QuoteSlice.vue?vue&type=script&lang=js&"
export * from "./QuoteSlice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports